module.exports = __webpack_public_path__ + "assets/img/thumb-ISS-Super-NRL-Partnership-Video.9f8563b9.jpg";